export default __webpack_public_path__ + "static/media/8.2a8b2450.webp";